export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in armeno',
      text: `Վաղեմ, ամենակարող, լեր Տեր,
Քեզ փառք, պատիվ և սուրհ,
և ամեն օրհնություն:
Միայն Քեզ, վաղեմ Տեր, մեծ դեմք,
և անմեկ մարդ չի արժանի անվանել Քո անունը:

Օրհնեմ Քեզ, իմ Տեր, բոլոր Քո ստեղծածների հետ,
հատկապես տիրիշ բայ Արևի հետ,
որ օրը մեզ է բերում և մեզ լուսավորում իր լույսով:
Այն գեղեցիկ է և փայլում մեծ փառքով.
Քեզ, վաղեմ Տեր, նշան է կրում:

Օրհնեմ Քեզ, իմ Տեր, քույր Լուսնի և աստղերի համար.
երկնքում Դու ստեղծեցիր դրանք պարզ,
թանկ և գեղեցիկ:

Օրհնեմ Քեզ, իմ Տեր, տեղյակ Հողմի համար
և օդի, ամպերի և맑은 երկնքի համար,
և բոլոր եղանակների համար, որով Դու տալիս ես
հաստիք Քո ստեղծածներին:

Օրհնեմ Քեզ, իմ Տեր, քույր Ջրի համար,
որը շատ օգտակար է
և հետեւ, թանկ և զուտ:

Օրհնեմ Քեզ, իմ Տեր, տեղյակ Հրէի համար,
որով Դու լուսավորում ես գիշերը,
և այն գեղեցիկ, ուրախ,
հզոր և ուժեղ:

Օրհնեմ Քեզ, իմ Տեր, մեր քույր Մայր-Երկրի համար,
որ կերակուր է մեզ և կառավարում,
և արտադրում տարբեր պտուղներ
բազմավածի ծաղիկներով և խոտերով:

Օրհնեմ Քեզ, իմ Տեր, նրանց համար, ովքեր հաք
Քո սիրո համար և ստանձնում են
հիվանդություն և տառalize:
Օրհնյալ նրանք, ովքեր կրում են սա խաղաղության մեջ
քանի որ Դու, վաղեմ Տեր, նրանց կստեփանավորես:

Օրհնեմ Քեզ, իմ Տեր, մեր քույր մարմնական Մահի համար,
որից կոր չի կարող փախչել կենդանի մարդ:
Վա՜յ նրանց, ովքեր մահանում են մահանալու մեղքով:
Օրհնյալ նրանք, ովքեր այն կգտնեն հատուկ
փուլի ցանկության մեջ,
քանի որ երկրորդ մահն ինձ վնաս չի կրի:

Օրհնեք և բարկացեք Տիրոջը,
և շնորհակալ եղեք Նրան,
և ծառայեք Նրան մեծ հետեւությամբ:`
    }
  }